/* @flow */

import View from './View';

export const getEditComponent = () => View;
export const getViewComponent = () => View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/agenda/index.js